import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { Sanity$FeatureContent } from '@otovo/shared/types/sanityTypes';
import { useRouter } from 'next/router';
import { PortablePTag } from '../../Sanity/PortableTextComponents';
import CTAButton from '../../v2/CTAButton';
import { routeToHref } from '../routeToHrefUtil';

type Props = {
  content: Sanity$FeatureContent;
  children?: React.ReactNode;
};

const FeatureContent = ({ content, children }: Props) => {
  const config = useGlobalConfig();
  const { locale } = useRouter() as { locale: Otovo$Locale };

  return (
    <div className="grid-cols-12 md:grid" data-testid="feature-content">
      <div className="col-span-6 mb-8 md:mb-0">
        {content.subHeading && (
          <h3 className="text-sx mb-3 font-medium text-balance text-heading uppercase">
            {content.subHeading}
          </h3>
        )}
        <h2 className="text-2xl font-semibold text-balance text-heading md:text-3xl lg:text-4xl">
          {content.heading}
        </h2>
      </div>
      <div className="col-span-5 col-start-8 space-y-6">
        <PortablePTag
          className="text-lg text-subheading md:text-xl"
          value={content.description}
        />

        {content.cta && (
          <div>
            <CTAButton
              href={routeToHref(
                content.cta.route,
                config.BU_CONFIG.market,
                locale,
              )}
            >
              {content.cta.title}
            </CTAButton>
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default FeatureContent;
